import { wccModules } from 'enums/wccModules';
import { inject, injectable } from 'inversify';
import './translationCheckbox.html';
import {CookieHelpers} from "../../../helpers/cookie";

@injectable()
export default class TranslationCheckbox {
    isTranslationShown = settings.ui.isTranslationShown
    title: string | undefined

    constructor(
        @inject(wccModules.componentInfo) info: ko.components.ComponentInfo
    ) {
        if(CookieHelpers.getCookie('qzy_gui_ShowThreadsTranslation') == undefined && WCC.Settings.NotNativeSpeaker === true) {
            this.isTranslationShown(true);
        }
        
        const translationLanguage = settings.translationLanguage;
        const translationCulture = settings.supportedCultures.find(culture => culture.Name === translationLanguage);

        this.title = translationCulture?.NativeName;

        ko.applyBindingsToNode(info.element, {
            'css': {
                'translation-checkbox': true
            }
        }, this);
    }    
}